// Auto-generated normalizer for table: CAR_BOOKING.ArchivosAdjuntos
export function archivosAdjuntosNormalize(row) {
  return {
    idAdjunto: row.idAdjunto ?? row.IdAdjunto ?? row['idAdjunto'] ?? 0,
    entidad: row.entidad ?? row.Entidad ?? row['entidad'] ?? '',
    idEntidad: row.idEntidad ?? row.IdEntidad ?? row['idEntidad'] ?? 0,
    nombreArchivo: row.nombreArchivo ?? row.NombreArchivo ?? row['nombreArchivo'] ?? '',
    rutaStorage: row.rutaStorage ?? row.RutaStorage ?? row['rutaStorage'] ?? '',
    contentType: row.contentType ?? row.ContentType ?? row['contentType'] ?? '',
    fechaCreacion: row.fechaCreacion ?? row.FechaCreacion ?? row['fechaCreacion'] ?? null,
    activo: row.activo ?? row.Activo ?? row['activo'] ?? false,
  };
}